import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    response: [],
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const ACTUALIZAR_BD_LOCAL = 'ACTUALIZAR_BD_LOCAL'
//*******************************************************************************************************************


//MÉTODOS 

export const hacerBackup = createAsyncThunk(
    ACTUALIZAR_BD_LOCAL,
    async () => {
        try {
            const fullUrl = host + `RespaldoOffline/hacerBackup`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosModoOffline = createSlice({

    name: 'metodosModoOffline',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [hacerBackup.fulfilled]: (state, { payload }) => {
            state.response = payload.data.data
        }
    },

})


export const { } = metodosModoOffline.actions
export const ModoOfflineReducer = metodosModoOffline.reducer